module.exports = "/_next/static/images/kyc-success-332e3ef97741ded8241fa59306265c2f.svg";